export default {
  API_RESOURCE: 'tasks',
  API_DISCUSSIONS_PATH: 'discussions'
}
